import React from 'react';

import { Link, Typography } from '@mui/material';
import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import { viewDetailsButton } from '../../Dashboards/Market/styles/style';
import { ViewDetailsButtonPropTypes } from '../../../interfaces/iproptypes';

const getClickableTextStyle = (color: string) => {
  return {
    color: color,
    textDecoration: 'underline',
    cursor: 'pointer',
    marginTop: '5px',
  };
};

const ViewDetailsButton = ({ isPreview, handlePreviewMode, color }: ViewDetailsButtonPropTypes) => {
  return (
    <Link sx={getClickableTextStyle(color)} onClick={() => handlePreviewMode()}>
      <Typography variant="caption" sx={viewDetailsButton}>
        {isPreview && <KeyboardBackspaceIcon />} {isPreview ? `Back` : `See smart insight`}{' '}
        {!isPreview && <ArrowRightAltOutlinedIcon />}
      </Typography>
    </Link>
  );
};

export default ViewDetailsButton;
